<template>
  <div v-if="image" :class="`sectionImage ` + clazz" :style="cssProp" @click="gotoLink"></div>
</template>
<script>
export default {
  props: {
    image: Object,
    src: String,
    width: String,
    height: String,
    link: String,
    clazz: String
  },
  // setup(props) {

  // },
  computed: {
    cssProp() {
      if (this.$props.src) {
        const image = this.$props.src || this.$props.image?.src || this.$props.image?.url;
        return {
          backgroundImage: `url(${image})`,
        }
      }

      const image = this.$props.image;
      const imageSrc = image.src || image.url || image.href;

      var computedStyle = { backgroundImage: `url(${imageSrc})`, height: `${image.height}px` };
      if (image.fixed_width) {
        computedStyle.width = `${image.width}px` ;
        computedStyle.margin = `auto`;
      }

      return computedStyle
    }
  },
  methods: {
    gotoLink() {
      let link = this.link || this.image?.href;
      if (link) {
        if (link.startsWith('http')) {
          window.location = link;
        } else {
          this.$router.push(link);
        }
      }
    }
  }
}
</script>
<style scoped>
.sectionImage {
  display: block;
  width: 100%;
  height: 159px;
  /* background-color: #ddd; */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
}

.no-radius {
  border-radius: 0;
}
</style>
